<template>
    <v-row justify="center" v-if="!editedItem || editedItem !== item" dense> 
      <v-col cols="9">
        <v-select
          dense
          outlined
          v-model="item.descriptionId"
          :items="getAcceptanceRuleDescriptions"
          item-text="description"
          item-value="id"
          label="Descrição"
          @change="updateItem(item, $event)"
          hide-details="true"
        ></v-select>  
      </v-col>
      <v-col cols="3">
        <v-btn fab x-small @click="editItem(item)">
          <v-icon x-small title="Adicionar">fas fa-plus</v-icon>
        </v-btn>  
      </v-col>
    </v-row>
    <v-row justify="center" v-else-if="editedItem && editedItem === item" dense>
      <v-col cols="7" >
        <v-text-field
          dense
          label="Descrição"
          v-model="description"
          outlined
          hide-details="true"
        />
      </v-col>
      <v-col cols="5">  
        <v-btn fab x-small @click="saveEdition" :disabled="processing || !description" :loading="processing" >
          <v-icon  x-small title="Adicionar">fas fa-check</v-icon>
        </v-btn>
        <v-btn fab x-small @click="cancelEdition" class="ml-2">
          <v-icon x-small title="Fechar">fas fa-times</v-icon>
        </v-btn>
      </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  props: {
    item: Object,
    acceptanceRuleDescriptions: Array
  },
  data() {
    return {
      editedItem: null,
      description: null,
      processing: false
    };
  },
  computed: {
    ...mapGetters("acceptanceRule", ["getAcceptanceRuleDescriptions"]),
  },
  methods: {
    ...mapActions("acceptanceRule", ["createAcceptanceRuleDescription"]),
    editItem(item) {
      this.editedItem = item;
    },
    cancelEdition() {
      this.editedItem = null
    },
    async saveEdition() {
      this.processing = true;
      let acceptanceRuleDescription = await this.createAcceptanceRuleDescription(
        {
          id: this.item.acceptanceRuleId, 
          acceptanceRuleDescription: {
            description: this.description
          }
        }
      );
      this.updateItem(this.editedItem, acceptanceRuleDescription.id);
      this.editedItem.descriptionId = acceptanceRuleDescription.id;
      this.description = null;
      this.processing = false;
      this.cancelEdition();
    },
    updateItem(item, acceptanceRuleDescriptionId) {
      this.$emit("on-description-created", item, acceptanceRuleDescriptionId);
    }
  }
};
</script>
